import { defineStore } from 'pinia';

export const useGlobalLabelsStore = defineStore('global-labels', {
    state: () => ({
        labels: {},
    }),
    actions: {
        storeLabels(label) {
            this.labels = label;
        },
    },
    getters: {
        getStoredLabels() {
            return this.labels;
        }
    }
});